import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import { parseDateValue } from "../../classes/utils/DateUtils";
import { GET_PATIENT_CONDITIONS_BY_IDS } from "../../queries/patientConditionQueries";

export function usePatientConditionsData(conditionIds) {
  const { data, loading, error, refetch } = useQuery(
    GET_PATIENT_CONDITIONS_BY_IDS,
    {
      variables: { ids: conditionIds },
      skip: !conditionIds?.length,
      fetchPolicy: "network-only",
    }
  );

  const patientConditions = useMemo(() => {
    return data?.patientConditionsByIds || [];
  }, [data]);

  const conditionsByDate = useMemo(() => {
    // Create a copy of the array before sorting (most recent first)
    return [...patientConditions].sort(
      (a, b) =>
        (parseDateValue(b.date)?.getTime() ?? 0) -
        (parseDateValue(a.date)?.getTime() ?? 0)
    );
  }, [patientConditions]);

  const latestConditions = useMemo(() => {
    return conditionsByDate[0] || null;
  }, [conditionsByDate]);

  const currentConditions = useMemo(() => {
    return latestConditions?.conditions || [];
  }, [latestConditions]);

  return {
    patientConditions,
    conditionsByDate,
    latestConditions,
    currentConditions,
    loading,
    error,
    refreshConditions: refetch,
  };
}
